/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */

import React from 'react';

import ReportTableConventer from 'reports/Common/ReportTableConventer';

class ReportTable extends React.Component {
  static defaultProps = {
    children: [],
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.children}
        <ReportTableConventer
          title={this.props.title}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          data={this.props.data}
          convertTo="v2"
        />
      </>
    );
  }
}

export default ReportTable;
